"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectMouseRunMode = exports.cancelRunMode = exports.setRunMode = exports.getRunMode = exports.update = exports.get = void 0;
// Handles holding down inputs (repeat movements)
var rogueInput_1 = require("./rogueInput");
var common_sidecar_1 = require("../../../main/common-sidecar");
var rogueInput_sidecar_1 = require("./rogueInput-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isRunning: false,
            isRunningStopped: false,
            runCommand: rogueInput_1.EInputCommand.none,
            isStarted: false,
            repeatTime: 0,
            repeatTimeMax: 0.1,
            repeatStartTime: 0,
            repeatStartTimeMax: 0.2,
        };
    }
    return _obj;
};
exports.get = get;
var update = function () {
    var dt = common_sidecar_1.common.getUpdateDelta();
    var obj = (0, exports.get)();
    if (obj.isRunning) {
        if (!obj.isStarted) {
            obj.repeatStartTime += dt;
            if (obj.repeatStartTime > obj.repeatStartTimeMax) {
                obj.isStarted = true;
                obj.repeatStartTime = 0;
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(obj.runCommand);
            }
            return;
        }
        obj.repeatTime += dt;
        if (obj.repeatTime > obj.repeatTimeMax) {
            obj.repeatTime = 0;
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(obj.runCommand);
        }
    }
};
exports.update = update;
var getRunMode = function () {
    var obj = (0, exports.get)();
    if (!obj.isRunning) {
        return rogueInput_1.EInputCommand.none;
    }
    return obj.runCommand;
};
exports.getRunMode = getRunMode;
var setRunMode = function (command) {
    var obj = (0, exports.get)();
    obj.isRunning = true;
    obj.isRunningStopped = false;
    obj.runCommand = command;
    obj.repeatTime = 0;
    obj.repeatStartTime = 0;
    obj.isStarted = false;
};
exports.setRunMode = setRunMode;
var cancelRunMode = function () {
    var obj = (0, exports.get)();
    obj.isRunning = false;
    obj.isRunningStopped = true;
};
exports.cancelRunMode = cancelRunMode;
// Mouse can run in multiple directions, so we need to redirect the run mode
var redirectMouseRunMode = function (command) {
    var obj = (0, exports.get)();
    if (obj.isRunning) {
        obj.runCommand = command;
    }
};
exports.redirectMouseRunMode = redirectMouseRunMode;
